import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { ReactComponent as CrossSimpleIconComponent } from 'assets/icons/cross-simple.svg';
import IconBtnComponent from 'components/common/IconBtn';
import { Colors } from 'styles/variables/colors';

const { darkGray, white } = Colors;

export const BtnWrapper = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const CrossSimpleIcon1 = styled(CrossSimpleIconComponent)`
    fill: ${darkGray};
`;

export const IconBtn1 = styled(IconBtnComponent)`
    height: 24px;
    width: 24px;
`;

export const Modal1 = styled.div<{ fullscreen: boolean }>`
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 100%;
    background: ${white};
    border-radius: 4px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);

    &:focus-visible {
        outline: none;
    }

    border-radius: ${({ fullscreen }) => (fullscreen ? '0px' : '')};
`;

export const ModalWrapper = styled.div<{ fullscreen: boolean }>`
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 22px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    max-height: 88%;
    max-width: 932px;
    height: 100%;
    width: 100%;
    overflow: hidden;

    ${({ fullscreen }) => {
        return fullscreen
            ? `
        max-width: 100%;
        max-height: 100%;
        padding: 0;
        border-radius: 0;
    `
            : '';
    }}
`;

export const reportButton = styled.button`
    height: 36px;
    width: 212px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: '#8353E2FF' })}
    background: #6025d8ff; /* white */
    opacity: 1;
    border: 1px solid #8353e2ff; /* border-s */
    border-radius: 3px;
    color: #ffffffff;
    line-height: 1.2;
    white-space: nowrap;
    margin-left: auto;
`;

export const divider = styled.span`
    height: 44px;
`;

export const Title = styled.h1`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    width: 100%;
    margin: 0;
    font-size: 26px;
    line-height: 1.2;
    font-weight: 700;
    letter-spacing: -0.01em;
`;
